import React from "react";
import artperfection2 from "../../images/artperfection-2.jpg";
import artperfection1 from "../../images/artperfection-1.jpg";
import "./contact.css";
import { Form, Input, Button, Select, DatePicker, Row, Col } from "antd";
import { FaLongArrowAltRight } from "react-icons/fa";
import emailjs from "@emailjs/browser";

const { Option } = Select;

interface ContactFormValues {
  from_name: string;
  from_contact: string;
  from_type?: string;
  from_date?: any; // dayjs type
  from_budget: string;
}

const Contact: React.FC = () => {
  const [form] = Form.useForm<ContactFormValues>();

  const onFinish = (values: ContactFormValues) => {
    const templateParams = {
      from_name: values.from_name,
      from_contact: values.from_contact,
      from_type: values.from_type,
      from_date: values.from_date ? values.from_date.format("YYYY-MM-DD") : "",
      from_budget: values.from_budget,
    };

    const serviceId = "service_8rnz923";
    const templateId = "template_tar03sf";
    const publicKey = "iORffhj9Ui-mbd7F3";

    emailjs.send(serviceId, templateId, templateParams, publicKey).then(
      () => {
        console.log("SUCCESS!");
        alert("Message sent successfully!");
        form.resetFields(); // reset form
      },
      (error) => {
        console.log("FAILED...", error.text);
        alert(`Failed: ${JSON.stringify(error)}`);
      }
    );
  };

  return (
    <div>
      {/* Header Section */}
      <section className="art bg-accent">
        <div className="container split flow-content">
          <div className="art__img">
            <div className="art__imgBox1">
              <img src={artperfection2} alt="" />
            </div>
            <div className="art__imgBox2">
              <img src={artperfection1} alt="" />
            </div>
          </div>
          <div className="contact__head">
            <h2>Contact Us</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit
              tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contactBlock">
        <div className="container split flow-content">
          <div className="contactBlock__img">
            <div className="contactBlock__imgBox">
              <img src={artperfection2} alt="" />
            </div>
          </div>

          <div className="contactBlock__form">
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              style={{ maxWidth: 700, margin: "0 auto" }}
            >
              {/* Row 1: Name & Contact */}
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="Name"
                    name="from_name"
                    rules={[
                      { required: true, message: "Please fill the Name field" },
                      {
                        min: 3,
                        message: "Name must be at least 3 characters long",
                      },
                    ]}
                  >
                    <Input placeholder="Enter your name" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label="Contact"
                    name="from_contact"
                    rules={[
                      {
                        required: true,
                        message: "Please fill the Contact field",
                      },
                      {
                        pattern: /^[0-9]{10}$/,
                        message: "Contact must be exactly 10 digits",
                      },
                    ]}
                  >
                    <Input
                      maxLength={10}
                      placeholder="Enter your contact number"
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Row 2: Event Type & Date */}
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Event Type" name="from_type">
                    <Select placeholder="Select event type">
                      <Option value="Birthday">Birthday</Option>
                      <Option value="Baby shower">Baby shower</Option>
                      <Option value="Bridal shower">Bridal shower</Option>
                      <Option value="Baby welcome party">
                        Baby welcome party
                      </Option>
                      <Option value="Haldi & Mehndi">Haldi & Mehndi</Option>
                      <Option value="Engagement">Engagement</Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item label="Event Date" name="from_date">
                    <DatePicker style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
              </Row>

              {/* Row 3: Budget */}
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="Budget"
                    name="from_budget"
                    rules={[
                      {
                        required: true,
                        message: "Please fill the Budget field",
                      },
                      {
                        validator: (_, value) => {
                          if (!value || Number(value) >= 30000) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error("Budget must be at least 30,000")
                          );
                        },
                      },
                    ]}
                  >
                    <Input type="number" placeholder="Enter your budget" />
                  </Form.Item>
                </Col>
              </Row>

              {/* Submit Button */}
              <Form.Item>
                <Button type="primary" htmlType="submit" block className="page__primary-btn">
                  <FaLongArrowAltRight /> Book Now
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
